export default __webpack_public_path__ + "static/media/sliders.f7f16983.svg";